module.exports = __webpack_public_path__ + "img/pexels-fauxels-3182759@2x.ee4eece8.png";